// extracted by mini-css-extract-plugin
module.exports = {"editInput":"TagManagmentListItem_editInput_2EzLU"};